import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const flutterService = {
	// Check if the app is a Flutter application
	isFlutterApp: () => typeof window.flutter_inappwebview !== 'undefined',
	//
	getFCMToken: async (): Promise<string | null> =>
		!flutterService.isFlutterApp() ? null : await window.getFCMToken(),
	//
	saveAuthToken: async (token: string) => (!flutterService.isFlutterApp() ? null : await window.saveAuthToken(token)),
	//
	getAuthToken: async (): Promise<string | null> =>
		!flutterService.isFlutterApp() ? null : await window.getAuthToken(),
	//
	getDeepLinkParams: (): { deepLink?: string; fcmToken?: string } => {
		// if (!flutterService.isFlutterApp()) {
		// 	return {}
		// }

		const params = new URLSearchParams(window.location.search)
		console.log('Flutter deep link params:', params.get('deepLink'), params.get('fcmToken'))
		return {
			deepLink: params.get('deepLink') || undefined,
			fcmToken: params.get('fcmToken') || undefined,
		}
	},
}

export const DeepLink = () => {
	const navigate = useNavigate()

	useEffect(() => {
		// Handle deep link navigation on app load
		const handleDeepLink = async () => {
			const params = flutterService.getDeepLinkParams()

			if (params.deepLink) {
				// Flutter sends the deep link path in the URL params
				console.log('Deep link received:', params.deepLink)

				// Navigate to the specified route
				navigate(params.deepLink)
			}

			// Store FCM token if provided
			if (params.fcmToken) {
				// Store FCM token for push notifications
				localStorage.setItem('fcmToken', params.fcmToken)
			}
		}

		handleDeepLink()
	}, [navigate])

	return <></>
}

export default flutterService
